export class CompanyModel {
  id: string;
  name: string;
  isMeepCardAccepted: boolean;
  requireNumberOnAssociate: number;

  // 1 - Obrigatorio
  // 2 - Opcional
  // 3 - Isento
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/company.model.ts